import PropTypes from 'prop-types';
import Fontawesome from 'react-fontawesome';

export const BaseContextItem = ({
  capitalize,
  icon,
  hide,
  children,
  units,
  ...props
}) => {
  if (hide || !children) return null;

  return (
    <div className="wp-usercard-context__item" {...props}>
      <Fontawesome fixedWidth name={icon} />
      <span className={capitalize ? 'capitalize' : ''}>{children}</span>
      {units && <span className="capitalize"> {units}</span>}
    </div>
  );
};

BaseContextItem.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.node,
  units: PropTypes.string,
};
